module.exports = __webpack_public_path__ + "img/AT0000002604799.4b1668af.png";